import PropTypes from "prop-types";
import React from "react";

const references = ({ children, isAnemia }) => (
	<div className={`references ${isAnemia ? "refs-anemia" : ""}`}>
		<div className="container">
			<div className="row">
				<div className="col">
					<p className="references-heading">References</p>
					<div className="references-body">{children}</div>
				</div>
			</div>
		</div>
	</div>
);

references.propTypes = {
	children: PropTypes.node.isRequired,
	isAnemia: PropTypes.bool
};

export default references;
